import z from 'zod';

export const addEventModelSchema = z.object({
  modelId: z.string().min(1, 'Type is required'),
  sizeId: z.string().min(1, 'Size is required'),
  position: z.array(z.string()).min(1, 'Position is required'),
  quantity: z.preprocess(
    (val) => {
      if (typeof val === 'string' && val.trim() !== '') {
        return Number(val);
      }
      if (typeof val === 'number') {
        return val;
      }
      return val;
    },
    z
      .number({
        required_error: 'Quantity left is required',
        invalid_type_error: 'Quantity left is required',
      })
      .min(0, 'Quantity left must be greater or equal to 0')
  ),
});
